// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: sans-serif;
}

.wizard_container__sQ9cQ {
  display: flex; /* Enable split-screen */
  height: 100vh;
  overflow: hidden;
}

.wizard_leftPane__lbQ0b {
  flex: 2 1; /* Allocate 2/3 of the width */
  overflow-y: auto;
  padding: 2em;
  background: #fff;
  color: #000;
  box-sizing: border-box;
}

.wizard_rightPane__NlFLd {
  flex: 1 1; /* Allocate 1/3 of the width */
  overflow-y: auto;
  background: #000;
  color: orange;
  padding: 1em;
  box-sizing: border-box;
}


.wizard_fieldset__KgSjF {
  border: none;
  margin-bottom: 2em;
  padding: 0;
}

.wizard_legend__j05UX {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 1em;
}

.wizard_formGroup__I0DAp {
  margin-bottom: 15px;
}

.wizard_label__x5\\+hV {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #000;
}

.wizard_input__UN7yr,
.wizard_textarea__LIvi3 {
  width: 100%;
  padding: 8px;
  font-size: 16px;
  /* Set consistent font size */
  font-family: 'Arial', sans-serif;
  /* Set consistent font */
  color: #333;
  /* Text color */
  background: #fff;
  /* Background color */
  border: 1px solid #ccc;
  /* Border color */
  border-radius: 4px;
  /* Rounded corners */
  box-sizing: border-box;
  margin-bottom: 10px;
  /* Consistent spacing */
}

.wizard_textarea__LIvi3 {
  min-height: 80px;
  /* Adjust height for textarea */
  resize: vertical;
  /* Allow vertical resizing */
}

.wizard_buttonContainer__J3XY5 {
  display: flex;
  justify-content: space-between;
  margin-top: 2em;
}

.wizard_navButton__yv-Vq {
  background: #333;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
}

.wizard_navButton__yv-Vq:hover {
  background: #111;
}

/* Reusable Buttons */
.wizard_addButton__Iuw1h,
.wizard_saveButton__EqF6J,
.wizard_addSecurityButton__G28Ft,
.wizard_removeButton__O56-c {
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.wizard_addButton__Iuw1h,
.wizard_addSecurityButton__G28Ft,
.wizard_addServerButton__nCNzE,
.wizard_addTagButton__BDtVL {
  width: 100%;
  padding: 10px;
  margin-top: 15px;
  font-size: 16px;
  background-color: #007bff;
  color: white;
}

.wizard_addButton__Iuw1h:hover,
.wizard_addSecurityButton__G28Ft:hover,
.wizard_addServerButton__nCNzE:hover,
.wizard_addTagButton__BDtVL:hover {
  background-color: #0056b3;
}

.wizard_saveButton__EqF6J {
  padding: 8px 15px;
  font-size: 14px;
  background-color: #28a745;
  color: white;
}

.wizard_saveButton__EqF6J:hover {
  background-color: #218838;
}

.wizard_removeButton__O56-c {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px 10px;
  background-color: #ff4d4d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.wizard_removeButton__O56-c:hover {
  background-color: #e60000;
}

/* Cards */
.wizard_tagCard__ZRgcc,
.wizard_serverCard__o6NAA {
  border: 1px solid #ccc;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 8px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}

/* Typography */
.wizard_tagCard__ZRgcc p,
.wizard_serverCard__o6NAA p {
  margin: 0;
  padding: 5px 0;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}

/* Label Styling for Strong Text */
.wizard_tagCard__ZRgcc strong,
.wizard_serverCard__o6NAA strong {
  color: #000;
  font-weight: bold;
}

.wizard_addButton__Iuw1h {
  width: 100%;
  padding: 10px;
  margin-top: 15px;
  font-size: 16px;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
}

.wizard_cancelButton__0kJBr {
  padding: 8px 15px;
  font-size: 14px;
  background-color: #FFA500;
  color: white;
}

.wizard_cancelButton__0kJBr:hover {
  background-color: #FFA500;
}

.wizard_navigationButtonGroup__dL8M0{
  display: flex;
  justify-content: space-between;
  margin-top: 20px
}

.wizard_previousButton__qvJHf{
  padding: 10px 15px;
  font-size: 16px;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.wizard_nextButton__op1Ec {
  padding: 10px 15px;
  font-size: 16px;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.wizard_nextButton__op1Ec.wizard_disabled__YyfdP {
  background-color: #ccc;
  cursor: not-allowed;
}

.wizard_primaryAddButton__ePFI1{
  width: 100%;
  padding: 10px;
  margin-top: 15px;
  font-size: 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
}

.wizard_primaryAddButton__ePFI1.wizard_disabled__YyfdP {
  background-color: #ccc;
  cursor: not-allowed;
}

.wizard_primaryFormButtons__k8FB- {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.wizard_primaryCancelButton__9MerX {
  margin-left: 10px;
  margin-top: 10px;
  padding: 10px 15px;
  background-color: red;
  color: black;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* Save button style */
.wizard_primarySaveButton__oQ973 {
  margin-top: 10px;
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.wizard_primaryErrorMessage__xJYZn{
  color: red;
  font-size: 00.9em
}

.wizard_primaryInputField__ltOAL {
  width: 100%;
  padding: 0.75em;
  font-size: 1em;
  margin-bottom: 1em;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  background: #fff;
  color: #000;
}

.wizard_primaryEditButton__8urc5 {
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.wizard_primaryDeleteButton__0ul7z {
  padding: 5px 10px;
  background-color: red;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
/* 
************************************Schema Related********************************************* */

/* ===========================
   General Styles
   =========================== */

/* Main Container */
.wizard_container__sQ9cQ {
  width: 100%;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* Title */
.wizard_title__RoUxw {
  margin-bottom: 10px;
}

/* Input Fields */
.wizard_inputField__MN3F6,
.wizard_selectField__mNS9P {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.wizard_inputField__MN3F6:disabled {
  background-color: #f0f0f0;
}

/* Grid Layout for Properties */
.wizard_propertyContainer__Y\\+hX8 {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f9f9f9;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 80px;
  gap: 10px;
  align-items: center;
}

/* Property Input Fields */
.wizard_propertyInput__T5VTB {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* Checkbox Container */
.wizard_checkboxContainer__iIJwi {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* Buttons */
.wizard_actionButton__HNCMW,
.wizard_button__9mwZi {
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.wizard_primaryButton__JYz7U {
  background-color: #007bff;
  color: white;
}

.wizard_primaryButton__JYz7U:hover {
  background-color: #0056b3;
}

.wizard_secondaryButton__or3cZ {
  background-color: #ccc;
  color: black;
}

.wizard_addButton__Iuw1h {
  margin-top: 10px;
  background-color: #28a745;
  color: white;
}

.wizard_editButton__SvAc2 {
  background-color: #007bff;
  color: white;
}

.wizard_deleteButton__qhkQt {
  background-color: red;
  color: white;
}

/* Remove Property Button */
.wizard_removeButton__O56-c {
  background-color: red;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  padding: 0;
}

/* ===========================
   Table Styles
   =========================== */
.wizard_schemaTable__Ysenc {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  margin-bottom: 20px;
}

.wizard_schemaTable__Ysenc th,
.wizard_schemaTable__Ysenc td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}

/* ===========================
   Schema List & Items
   =========================== */
.wizard_schemaListContainer__zug92 {
  width: 100%;
}

.wizard_schemaItem__aMXdk {
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  position: relative;
  padding-bottom: 10px;
}

/* Schema Items */
.wizard_schemaItems__Hv07g {
  margin-top: 5px;
  font-style: italic;
}

/* Schema Actions (Edit/Delete Buttons) */
.wizard_schemaActions__mfQXj {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 10px;
}

/* ===========================
   Popup & Overlay
   =========================== */
.wizard_popupOverlay__5BDob {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.wizard_popup__WQDxJ {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.wizard_popupCloseButton__kLNE6 {
  margin-top: 10px;
  background-color: #007bff;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* ===========================
   Empty Message & Headers
   =========================== */
.wizard_emptyMessage__cls\\+3 {
  font-style: italic;
  color: #666;
}

.wizard_noSchemasMessage__9xRlF {
  text-align: center;
  font-style: italic;
  color: #666;
}

/* ===========================
   Add Schema Button
   =========================== */
.wizard_addSchemaButton__nUt1Y {
  width: 100%;
  padding: 10px;
  margin-top: 15px;
  font-size: 16px;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wizard_addSchemaButton__nUt1Y:hover {
  background-color: #0056b3;
}


`, "",{"version":3,"sources":["webpack://./src/wizard.module.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa,EAAE,wBAAwB;EACvC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO,EAAE,8BAA8B;EACvC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAO,EAAE,8BAA8B;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;;;;EAIE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;EAIE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;;EAEE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,eAAe;AACf;;EAEE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,kCAAkC;AAClC;;EAEE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;iGACiG;;AAEjG;;gCAEgC;;AAEhC,mBAAmB;AACnB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,YAAY;AACZ;;EAEE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;;AAEA;;gCAEgC;AAChC;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;gCAEgC;AAChC;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;;gCAEgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;gCAEgC;AAChC;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;gCAEgC;AAChC;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["html,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  font-family: sans-serif;\n}\n\n.container {\n  display: flex; /* Enable split-screen */\n  height: 100vh;\n  overflow: hidden;\n}\n\n.leftPane {\n  flex: 2; /* Allocate 2/3 of the width */\n  overflow-y: auto;\n  padding: 2em;\n  background: #fff;\n  color: #000;\n  box-sizing: border-box;\n}\n\n.rightPane {\n  flex: 1; /* Allocate 1/3 of the width */\n  overflow-y: auto;\n  background: #000;\n  color: orange;\n  padding: 1em;\n  box-sizing: border-box;\n}\n\n\n.fieldset {\n  border: none;\n  margin-bottom: 2em;\n  padding: 0;\n}\n\n.legend {\n  font-size: 1.2em;\n  font-weight: bold;\n  margin-bottom: 1em;\n}\n\n.formGroup {\n  margin-bottom: 15px;\n}\n\n.label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n  color: #000;\n}\n\n.input,\n.textarea {\n  width: 100%;\n  padding: 8px;\n  font-size: 16px;\n  /* Set consistent font size */\n  font-family: 'Arial', sans-serif;\n  /* Set consistent font */\n  color: #333;\n  /* Text color */\n  background: #fff;\n  /* Background color */\n  border: 1px solid #ccc;\n  /* Border color */\n  border-radius: 4px;\n  /* Rounded corners */\n  box-sizing: border-box;\n  margin-bottom: 10px;\n  /* Consistent spacing */\n}\n\n.textarea {\n  min-height: 80px;\n  /* Adjust height for textarea */\n  resize: vertical;\n  /* Allow vertical resizing */\n}\n\n.buttonContainer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 2em;\n}\n\n.navButton {\n  background: #333;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 10px;\n  margin: 5px;\n  cursor: pointer;\n}\n\n.navButton:hover {\n  background: #111;\n}\n\n/* Reusable Buttons */\n.addButton,\n.saveButton,\n.addSecurityButton,\n.removeButton {\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.addButton,\n.addSecurityButton,\n.addServerButton,\n.addTagButton {\n  width: 100%;\n  padding: 10px;\n  margin-top: 15px;\n  font-size: 16px;\n  background-color: #007bff;\n  color: white;\n}\n\n.addButton:hover,\n.addSecurityButton:hover,\n.addServerButton:hover,\n.addTagButton:hover {\n  background-color: #0056b3;\n}\n\n.saveButton {\n  padding: 8px 15px;\n  font-size: 14px;\n  background-color: #28a745;\n  color: white;\n}\n\n.saveButton:hover {\n  background-color: #218838;\n}\n\n.removeButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  padding: 5px 10px;\n  background-color: #ff4d4d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.removeButton:hover {\n  background-color: #e60000;\n}\n\n/* Cards */\n.tagCard,\n.serverCard {\n  border: 1px solid #ccc;\n  padding: 15px;\n  margin-bottom: 15px;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n/* Typography */\n.tagCard p,\n.serverCard p {\n  margin: 0;\n  padding: 5px 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #333;\n}\n\n/* Label Styling for Strong Text */\n.tagCard strong,\n.serverCard strong {\n  color: #000;\n  font-weight: bold;\n}\n\n.addButton {\n  width: 100%;\n  padding: 10px;\n  margin-top: 15px;\n  font-size: 16px;\n  cursor: pointer;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n}\n\n.cancelButton {\n  padding: 8px 15px;\n  font-size: 14px;\n  background-color: #FFA500;\n  color: white;\n}\n\n.cancelButton:hover {\n  background-color: #FFA500;\n}\n\n.navigationButtonGroup{\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px\n}\n\n.previousButton{\n  padding: 10px 15px;\n  font-size: 16px;\n  background-color: #333;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.nextButton {\n  padding: 10px 15px;\n  font-size: 16px;\n  background-color: #333;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.nextButton.disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.primaryAddButton{\n  width: 100%;\n  padding: 10px;\n  margin-top: 15px;\n  font-size: 16px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n}\n\n.primaryAddButton.disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.primaryFormButtons {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.primaryCancelButton {\n  margin-left: 10px;\n  margin-top: 10px;\n  padding: 10px 15px;\n  background-color: red;\n  color: black;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* Save button style */\n.primarySaveButton {\n  margin-top: 10px;\n  padding: 10px 15px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.primaryErrorMessage{\n  color: red;\n  font-size: 00.9em\n}\n\n.primaryInputField {\n  width: 100%;\n  padding: 0.75em;\n  font-size: 1em;\n  margin-bottom: 1em;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n  background: #fff;\n  color: #000;\n}\n\n.primaryEditButton {\n  padding: 5px 10px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.primaryDeleteButton {\n  padding: 5px 10px;\n  background-color: red;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n/* \n************************************Schema Related********************************************* */\n\n/* ===========================\n   General Styles\n   =========================== */\n\n/* Main Container */\n.container {\n  width: 100%;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n/* Title */\n.title {\n  margin-bottom: 10px;\n}\n\n/* Input Fields */\n.inputField,\n.selectField {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-bottom: 10px;\n  box-sizing: border-box;\n}\n\n.inputField:disabled {\n  background-color: #f0f0f0;\n}\n\n/* Grid Layout for Properties */\n.propertyContainer {\n  margin-bottom: 10px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #f9f9f9;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 80px;\n  gap: 10px;\n  align-items: center;\n}\n\n/* Property Input Fields */\n.propertyInput {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n/* Checkbox Container */\n.checkboxContainer {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n/* Buttons */\n.actionButton,\n.button {\n  padding: 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.primaryButton {\n  background-color: #007bff;\n  color: white;\n}\n\n.primaryButton:hover {\n  background-color: #0056b3;\n}\n\n.secondaryButton {\n  background-color: #ccc;\n  color: black;\n}\n\n.addButton {\n  margin-top: 10px;\n  background-color: #28a745;\n  color: white;\n}\n\n.editButton {\n  background-color: #007bff;\n  color: white;\n}\n\n.deleteButton {\n  background-color: red;\n  color: white;\n}\n\n/* Remove Property Button */\n.removeButton {\n  background-color: red;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 14px;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  padding: 0;\n}\n\n/* ===========================\n   Table Styles\n   =========================== */\n.schemaTable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n\n.schemaTable th,\n.schemaTable td {\n  border: 1px solid #ccc;\n  padding: 8px;\n  text-align: center;\n}\n\n/* ===========================\n   Schema List & Items\n   =========================== */\n.schemaListContainer {\n  width: 100%;\n}\n\n.schemaItem {\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin-bottom: 10px;\n  border-radius: 4px;\n  position: relative;\n  padding-bottom: 10px;\n}\n\n/* Schema Items */\n.schemaItems {\n  margin-top: 5px;\n  font-style: italic;\n}\n\n/* Schema Actions (Edit/Delete Buttons) */\n.schemaActions {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  gap: 10px;\n}\n\n/* ===========================\n   Popup & Overlay\n   =========================== */\n.popupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.popup {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.popupCloseButton {\n  margin-top: 10px;\n  background-color: #007bff;\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* ===========================\n   Empty Message & Headers\n   =========================== */\n.emptyMessage {\n  font-style: italic;\n  color: #666;\n}\n\n.noSchemasMessage {\n  text-align: center;\n  font-style: italic;\n  color: #666;\n}\n\n/* ===========================\n   Add Schema Button\n   =========================== */\n.addSchemaButton {\n  width: 100%;\n  padding: 10px;\n  margin-top: 15px;\n  font-size: 16px;\n  cursor: pointer;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.addSchemaButton:hover {\n  background-color: #0056b3;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `wizard_container__sQ9cQ`,
	"leftPane": `wizard_leftPane__lbQ0b`,
	"rightPane": `wizard_rightPane__NlFLd`,
	"fieldset": `wizard_fieldset__KgSjF`,
	"legend": `wizard_legend__j05UX`,
	"formGroup": `wizard_formGroup__I0DAp`,
	"label": `wizard_label__x5+hV`,
	"input": `wizard_input__UN7yr`,
	"textarea": `wizard_textarea__LIvi3`,
	"buttonContainer": `wizard_buttonContainer__J3XY5`,
	"navButton": `wizard_navButton__yv-Vq`,
	"addButton": `wizard_addButton__Iuw1h`,
	"saveButton": `wizard_saveButton__EqF6J`,
	"addSecurityButton": `wizard_addSecurityButton__G28Ft`,
	"removeButton": `wizard_removeButton__O56-c`,
	"addServerButton": `wizard_addServerButton__nCNzE`,
	"addTagButton": `wizard_addTagButton__BDtVL`,
	"tagCard": `wizard_tagCard__ZRgcc`,
	"serverCard": `wizard_serverCard__o6NAA`,
	"cancelButton": `wizard_cancelButton__0kJBr`,
	"navigationButtonGroup": `wizard_navigationButtonGroup__dL8M0`,
	"previousButton": `wizard_previousButton__qvJHf`,
	"nextButton": `wizard_nextButton__op1Ec`,
	"disabled": `wizard_disabled__YyfdP`,
	"primaryAddButton": `wizard_primaryAddButton__ePFI1`,
	"primaryFormButtons": `wizard_primaryFormButtons__k8FB-`,
	"primaryCancelButton": `wizard_primaryCancelButton__9MerX`,
	"primarySaveButton": `wizard_primarySaveButton__oQ973`,
	"primaryErrorMessage": `wizard_primaryErrorMessage__xJYZn`,
	"primaryInputField": `wizard_primaryInputField__ltOAL`,
	"primaryEditButton": `wizard_primaryEditButton__8urc5`,
	"primaryDeleteButton": `wizard_primaryDeleteButton__0ul7z`,
	"title": `wizard_title__RoUxw`,
	"inputField": `wizard_inputField__MN3F6`,
	"selectField": `wizard_selectField__mNS9P`,
	"propertyContainer": `wizard_propertyContainer__Y+hX8`,
	"propertyInput": `wizard_propertyInput__T5VTB`,
	"checkboxContainer": `wizard_checkboxContainer__iIJwi`,
	"actionButton": `wizard_actionButton__HNCMW`,
	"button": `wizard_button__9mwZi`,
	"primaryButton": `wizard_primaryButton__JYz7U`,
	"secondaryButton": `wizard_secondaryButton__or3cZ`,
	"editButton": `wizard_editButton__SvAc2`,
	"deleteButton": `wizard_deleteButton__qhkQt`,
	"schemaTable": `wizard_schemaTable__Ysenc`,
	"schemaListContainer": `wizard_schemaListContainer__zug92`,
	"schemaItem": `wizard_schemaItem__aMXdk`,
	"schemaItems": `wizard_schemaItems__Hv07g`,
	"schemaActions": `wizard_schemaActions__mfQXj`,
	"popupOverlay": `wizard_popupOverlay__5BDob`,
	"popup": `wizard_popup__WQDxJ`,
	"popupCloseButton": `wizard_popupCloseButton__kLNE6`,
	"emptyMessage": `wizard_emptyMessage__cls+3`,
	"noSchemasMessage": `wizard_noSchemasMessage__9xRlF`,
	"addSchemaButton": `wizard_addSchemaButton__nUt1Y`
};
export default ___CSS_LOADER_EXPORT___;
